module.exports = __webpack_public_path__ + "static/media/clear_search_ic.a13730a9.svg";